// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".main-card .small-text {\n  font-size: 12px;\n  top: -9px;\n  padding: 0;\n  position: relative;\n  font-weight: 500;\n  color: grey;\n}", ""]);
// Exports
module.exports = exports;
